import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

// Prime-React Components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';
import { Badge } from 'primereact/badge';

// Redux-Actions
import {
  getInterviewersInvitation,
  getInterviewersSchedule
} from '../../redux/actions/interviewers';
import { interviewerInterviewDetailAction } from '../../redux/actions/userDetails';
import {
  cancelInterviewRoundAction,
  interviewInvitaionStatus
} from '../../redux/actions/interviews';

// Contants
import { INTERVIEWER } from '../../constants/tableColumns';
import {
  ACTION_TYPE,
  INTERVIEW_INVITATION_STATUS,
  INTERVIEW_TYPE,
  ROUTES,
  STATUS
} from '../../constants/common';

// Utils
import { formatTime, getFormattedDateView } from '../../utils/date';
import { wordCapitalize } from '../../utils/common';

// Components
import {
  ActionButtonsForInvitationInterview,
  ActionButtonsForSceduledInterview
} from '../../components/ActionButtons';
import AddEditFeedback from '../../components/popup/AddEditFeedback';
import InterviewDetails from '../../components/popup/InterviewDetails';
import CustomButton from '../../components/CustomButton';

// Redux-Slices
import { apiStatusClear } from '../../redux/slices/apiStatus';
import { redirectionOnStatusChange } from '../../redux/slices/interviews';
import { getNotification } from '../../redux/slices/notification';
import moment from 'moment';
import ConfirmDialogWithReason from '../../components/ConfirmDialogWithReasonForInterview';

const InterviewerDashboardTable = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex flex-wrap interviewer-table-header">
        <h5 className="flex align-items-center white-space-nowrap mr-2 mb-0">{props.tableName}</h5>
        <div className="flex justify-content-between align-items-center flex-1 mb-0 button-wrapper">
          <Badge
            value={`Total : ${props?.totalRecords || 0}`}
            className="white-space-nowrap"></Badge>
          <CustomButton variant="contained" onClick={() => navigate(props.redirect)}>
            View all
          </CustomButton>
        </div>
      </div>
      <div className="white-box custom-table-wrapper p-0 overflow-hidden">
        <DataTable size="small" value={props.tableData} responsiveLayout="scroll">
          {props.tableColumns.map((column, index) => {
            return (
              <Column
                key={index}
                field={column.field}
                header={column.header}
                className={column.class}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};

const InterviewerDashboard = () => {
  const navigate = useNavigate();

  // Redux hooks.
  const dispatch = useDispatch();
  const { scheduleData, invitationData, feedbackData } = useSelector(
    (state) => state.interviewerDashboard
  );
  const { redirection, invitationStatus } = useSelector((state) => state.interviews);
  const { userDetails } = useSelector((state) => state);
  const { isNotification } = useSelector((state) => state.notification);

  // React useState hooks.
  const [scheduleList, setScheduleList] = useState([]);
  const [invitationList, setInvitationList] = useState([]);
  const [interviewId, setInterviewId] = useState(null);
  const [interviewDetails, setInterviewDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [typeInterview, setTypeInterview] = useState(null);
  const [interviewRoundMode, setInterviewRoundMode] = useState(null);
  const [getCandidateName, setCandidateName] = useState('');
  const [getCandidateId, setCandidateId] = useState(null);
  const [invitationId, setInvitationId] = useState(null);
  const [interviewDate, setInterviewDate] = useState(null);
  const [interviewCategory, setInterviewCategory] = useState(null);
  const [interviewRoundId, setInterviewRoundId] = useState(null);
  const [cancelConfirmBoxVisibility, setCancelConfirmBoxVisibility] = useState(false);
  const [displayConfirmAction, setDisplayConfirmAction] = useState(false);

  const onToggleFeedbackPopup = (value) => setShowFeedbackPopup(value);
  const onTogglePopup = () => setShowPopup((prevState) => !prevState);

  const handleView = (ID) => {
    if (ID) {
      onTogglePopup();
      setInterviewId(ID);
    }
  };

  // React useEffect hooks.
  useEffect(() => {
    interviewId && dispatch(interviewerInterviewDetailAction(interviewId));
  }, [dispatch, interviewId]);

  const modifyInterviewDetails = useCallback(() => {
    if (userDetails?.Interview?.Candidate && userDetails?.HROfRound) {
      setInterviewDetails({
        'Interview Details': {
          'Start Date': `${getFormattedDateView(
            userDetails?.StartDateOfInterviewRound
          )} ${formatTime(userDetails?.StartDateOfInterviewRound || '')} `,
          'End Date': `${getFormattedDateView(userDetails?.EndDateOfInterviewRound)} ${formatTime(
            userDetails?.EndDateOfInterviewRound || ''
          )} `,
          'Interview Type': `${INTERVIEW_TYPE.filter(
            (num) => num.code === userDetails?.InterviewRound
          ).map((type) => type.name)}`,
          Technology:
            userDetails?.Interview?.Candidate.UMap &&
            userDetails?.Interview?.Candidate.UMap.length > 0
              ? userDetails?.Interview?.Candidate.UMap?.map((tech) =>
                  wordCapitalize(tech.MapT.Technology)
                ).join(', ')
              : null,
          'Job Designation': userDetails?.Interview?.JobDesignation
            ? userDetails?.Interview?.JobDesignation?.Designation
            : '--'
        },
        'Candidate Details': {
          Name: `${wordCapitalize(userDetails?.Interview?.Candidate?.FirstName) || ''} ${
            wordCapitalize(userDetails?.Interview?.Candidate?.LastName) || ''
          }`,
          // Email: (
          //   <div className="center">
          //     <span>{userDetails?.Interview?.Candidate?.Email || '--'}</span>
          //     {userDetails?.Interview?.Candidate?.Email && (
          //       <>
          //         <i
          //           data-tip="Copied"
          //           data-event="click focus"
          //           data-for={`copyIcon_${userDetails?.Interview?.Candidate?.Email}`}
          //           id={`copyIcon_${userDetails?.Interview?.Candidate?.Email}`}
          //           className="pi pi-fw pi-copy ml-1 copy-icon"
          //         />
          //         <ReactTooltip
          //           id={`copyIcon_${userDetails?.Interview?.Candidate?.Email}`}
          //           globalEventOff="click"
          //           afterShow={() => {
          //             navigator.clipboard.writeText(userDetails?.Interview?.Candidate?.Email);
          //             setTimeout(() => {
          //               ReactTooltip.hide();
          //             }, 500);
          //           }}
          //         />
          //       </>
          //     )}
          //   </div>
          // ),
          Experience:
            `${userDetails?.Interview?.Candidate?.YearsOfExperience} Years` +
            `${
              userDetails?.Interview?.Candidate?.MonthsOfExperience
                ? ` ${userDetails?.Interview?.Candidate?.MonthsOfExperience} Months`
                : ''
            }`
        },
        'HR Details': {
          Name: `${userDetails?.HROfRound?.FirstName || ''} ${
            userDetails?.HROfRound?.LastName || ''
          }`
          // Email: (
          //   <div className="center">
          //     <span>{userDetails?.HR?.Email || '--'}</span>
          //     {userDetails?.HR?.Email && (
          //       <>
          //         <i
          //           data-tip="Copied"
          //           data-event="click focus"
          //           data-for={`copyIcon_${userDetails?.HR?.Email}`}
          //           id={`copyIcon_${userDetails?.HR?.Email}`}
          //           className="pi pi-fw pi-copy ml-1 copy-icon"
          //         />
          //         <ReactTooltip
          //           id={`copyIcon_${userDetails?.HR?.Email}`}
          //           globalEventOff="click"
          //           afterShow={() => {
          //             navigator.clipboard.writeText(userDetails?.HR?.Email);
          //             setTimeout(() => {
          //               ReactTooltip.hide();
          //             }, 500);
          //           }}
          //         />
          //       </>
          //     )}
          //   </div>
          // )
        }
      });
    }
  }, [userDetails]);

  useEffect(() => {
    modifyInterviewDetails();
  }, [userDetails, modifyInterviewDetails]);

  useEffect(() => {
    if (interviewDate && invitationId) {
      setDisplayConfirmAction(true);
    } else {
      setDisplayConfirmAction(false);
    }
  }, [invitationId, interviewDate]);

  useEffect(() => {
    if (redirection) {
      setDisplayConfirmAction(false);
      if (invitationStatus == STATUS.ACCEPT) {
        navigate(ROUTES.INTERVIEWER.INTERVIEW_SCHEDULED);
        toast.success('Invitation Accepted Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        dispatch(apiStatusClear());
        dispatch(redirectionOnStatusChange({ redirection: false, invitationStatus }));
      } else {
        dispatch(redirectionOnStatusChange({ redirection: false, invitationStatus }));
      }
    }
  }, [redirection, navigate, dispatch]);

  useEffect(() => {
    const modifiedData = (interviews, tableName) =>
      interviews?.map((data) => {
        const { InterviewRound, Status } = data;
        const { Interview, ID, Description, StartDateOfInterviewRound } = InterviewRound;
        const candidateName = `${
          Interview?.Candidate?.FirstName ? wordCapitalize(Interview.Candidate?.FirstName) : ''
        } ${Interview?.Candidate?.LastName ? wordCapitalize(Interview.Candidate?.LastName) : ''}`;
        return {
          ...data,
          CandidateName: (
            <Link to="#" className="table-view-popup-link" onClick={() => handleView(ID)}>
              {candidateName}
            </Link>
          ),
          HrName: `${
            InterviewRound?.HROfRound?.FirstName
              ? wordCapitalize(InterviewRound.HROfRound?.FirstName)
              : ''
          } ${
            InterviewRound.HROfRound?.LastName
              ? wordCapitalize(InterviewRound.HROfRound?.LastName)
              : ''
          }`,
          StartDateOfInterviewRound: `${getFormattedDateView(
            InterviewRound.StartDateOfInterviewRound
          )} ${formatTime(InterviewRound.StartDateOfInterviewRound)}`,
          InterviewType: (
            <ul className="technology-list">
              {Interview?.Candidate.UMap && Interview?.Candidate?.UMap?.length > 0
                ? Interview.Candidate.UMap?.map((tech) => (
                    <li
                      key={tech.MapT.Technology}
                      className="technology-badge"
                      style={{ background: tech.MapT.TechnologyColor }}>
                      {tech.MapT.Technology}
                    </li>
                  ))
                : []}
            </ul>
          ),
          JobDesignation:
            Interview?.JobDesignation && wordCapitalize(Interview?.JobDesignation?.Designation),
          RoundOfInterview: `${INTERVIEW_TYPE.filter(
            (num) => num.code === InterviewRound.InterviewRound
          ).map((type) => type.name)}`,
          Description: Description || '',
          Status: (
            <Badge
              key={Status}
              value={INTERVIEW_INVITATION_STATUS[Status]}
              className={`white-space-nowrap ${
                Status === STATUS.ACCEPT
                  ? 'complete-badge'
                  : Status === STATUS.ACCEPT_BY_OTHER
                  ? 'reschedule-badge'
                  : Status === STATUS.PENDING
                  ? 'pending-badge'
                  : 'cancel-badge'
              }`}
            />
          ),
          action: (
            <>
              {tableName === "Today's interviews" ? (
                <div className="flex align-items-center">
                  <ActionButtonsForSceduledInterview
                    onClick={(actionType) =>
                      handleRowActions(
                        actionType,
                        InterviewRound.ID,
                        InterviewRound.InterviewRoundMode,
                        InterviewRound?.InterviewRound,
                        candidateName,
                        InterviewRound?.Interview?.Candidate?.ID,
                        Interview?.InterviewCategory
                      )
                    }
                    disabled={moment(moment()).isBefore(
                      InterviewRound.StartDateOfInterviewRound,
                      'minute'
                    )}
                  />
                </div>
              ) : (
                ''
              )}

              {tableName === 'Interview Invitations' ? (
                <div className="flex align-items-center">
                  <ActionButtonsForInvitationInterview
                    disabled={Status !== STATUS.PENDING}
                    onClick={(actionType, e) =>
                      handleInvitationRowActions(
                        actionType,
                        InterviewRound.ID,
                        data.ID,
                        StartDateOfInterviewRound,
                        e
                      )
                    }
                  />
                </div>
              ) : (
                ''
              )}
            </>
          )
        };
      });
    setScheduleList(modifiedData(scheduleData?.scheduleInterview, "Today's interviews"));
    setInvitationList(modifiedData(invitationData?.interviewInvitations, 'Interview Invitations'));
  }, [scheduleData, invitationData, feedbackData, redirection]);

  useEffect(() => {
    dispatch(getInterviewersInvitation());
    dispatch(getInterviewersSchedule());
    if (isNotification) {
      dispatch(getNotification(false));
    }
  }, [dispatch, redirection, isNotification]);

  useEffect(() => {
    if (!interviewRoundId) {
      setCancelConfirmBoxVisibility(false);
    }
  }, [interviewRoundId]);

  const dashboardTables = [
    {
      name: "Today's interviews",
      data: scheduleList,
      columns: INTERVIEWER.SCHEDULED_INTERVIEW_COLUMNS,
      redirect: ROUTES.INTERVIEWER.INTERVIEW_SCHEDULED,
      totalRecords: scheduleData?.totalRecords
    },
    {
      name: 'Interview Invitations',
      data: invitationList,
      columns: INTERVIEWER.INTERVIEW_INVITATION_COLUMNS,
      redirect: ROUTES.INTERVIEWER.INTERVIEW_INVITATION,
      totalRecords: invitationData?.totalRecords
    }
  ];

  const handleRowActions = (
    actionType,
    rowId,
    mode,
    type,
    candidateName,
    candidateId,
    interviewCategory
  ) => {
    if (actionType === ACTION_TYPE.FEEDBACK) {
      setTypeInterview(type);
      setCandidateName(candidateName);
      setInterviewRoundMode(mode);
      setCandidateId(candidateId);
      setInterviewCategory(interviewCategory);
      if (rowId) {
        onToggleFeedbackPopup(true);
        setInterviewId(rowId);
      }
    } else if (actionType === ACTION_TYPE.CANCEL) {
      setCandidateName(candidateName);
      setInterviewRoundId(rowId);
      setCancelConfirmBoxVisibility(true);
    }
  };

  const handleInvitationRowActions = (actionType, rowId, acceptRejectId, date) => {
    if (actionType === ACTION_TYPE.ACCEPT) {
      const interviewDate = `${getFormattedDateView(date)} at ${formatTime(date)}`;
      const dateOfInterview = `${getFormattedDateView(interviewDate)}`;
      const TodaysDate = `${getFormattedDateView(new Date())}`;
      if (TodaysDate === dateOfInterview) {
        confirmDialog({
          message: (
            <>
              This interview is scheduled for <strong>{interviewDate}</strong> (TODAY). Are you sure
              you want to accept?
            </>
          ),
          header: 'Accept',
          icon: 'pi pi-exclamation-triangle',
          accept: () =>
            dispatch(
              interviewInvitaionStatus({ id: acceptRejectId, invitationStatus: STATUS.ACCEPT })
            )
        });
      } else {
        confirmDialog({
          message: (
            <>
              This interview is scheduled for <strong>{interviewDate}</strong>. Are you sure you
              want to accept?
            </>
          ),
          header: 'Accept',
          icon: 'pi pi-exclamation-triangle',
          accept: () =>
            dispatch(
              interviewInvitaionStatus({ id: acceptRejectId, invitationStatus: STATUS.ACCEPT })
            )
        });
      }
    } else if (actionType === ACTION_TYPE.REJECT) {
      const interviewDate = `${getFormattedDateView(date)} at ${formatTime(date)}`;
      setInvitationId(acceptRejectId);
      setInterviewDate(interviewDate);
    }
  };

  return (
    <>
      <AddEditFeedback
        id={interviewId}
        onHide={onToggleFeedbackPopup}
        show={showFeedbackPopup}
        interviewType={typeInterview}
        interviewRoundMode={interviewRoundMode}
        candidateId={getCandidateId || ''}
        interviewRoundId={interviewId}
        interviewCategory={interviewCategory}
        confirmDialogMessage={
          <>
            Are you sure you want to submit the feedback for the{' '}
            <strong>{getCandidateName ? wordCapitalize(getCandidateName) : ''}</strong>
            {''} candidate?
          </>
        }
      />
      <InterviewDetails data={interviewDetails} onHide={onTogglePopup} show={showPopup} />
      <ConfirmDialogWithReason
        bodyTitle={
          <>
            Are you sure you want to cancel the interview for{' '}
            <strong> &nbsp;{getCandidateName}?</strong>
          </>
        }
        interviewId={interviewRoundId}
        dialogHeader="Cancel interview"
        setInterviewId={setInterviewRoundId}
        displayConfirmAction={cancelConfirmBoxVisibility}
        ishandleSuccess
        isReasonRequired
        onSuccess={(payload) => {
          dispatch(cancelInterviewRoundAction(payload));
          setTimeout(() => {
            dispatch(getInterviewersSchedule());
            setCancelConfirmBoxVisibility(false);
          }, 250);
        }}
      />
      <ConfirmDialogWithReason
        bodyTitle={
          <span>
            This interview is scheduled for <strong>{interviewDate}</strong>{' '}
            {getFormattedDateView(new Date()) === getFormattedDateView(interviewDate)
              ? ' (TODAY)'
              : ''}
            . Are you sure you want to reject?
          </span>
        }
        interviewId={invitationId}
        dialogHeader="Reject Invitation"
        setInterviewId={setInvitationId}
        displayConfirmAction={displayConfirmAction}
        isReasonRequired
        handleSubmit={(values) => {
          dispatch(
            interviewInvitaionStatus({
              id: invitationId,
              rejectionReason: values.cancelReason,
              invitationStatus: STATUS.REJECT
            })
          );
        }}
      />
      {dashboardTables.map((table, index) => {
        return (
          <div className="card interviewer-dashboard-card " key={index}>
            <InterviewerDashboardTable
              tableName={table.name}
              tableColumns={table.columns}
              tableData={table.data}
              redirect={table.redirect}
              totalRecords={table.totalRecords}
            />
          </div>
        );
      })}
    </>
  );
};

export default InterviewerDashboard;
